import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {} from '../custom-styled-components/_MyCustomSC';
import { isDevENV } from '../../../util/isDevENV';
import NumericCustomInput from '../NumericCustomInput';
import { InputNumber, Input, Select, Form } from 'antd';

const { Option } = Select;

const weightUnitArr = ['KG', 'LB'];
const volumeUnitArr = ['CBM', 'CFT'];

const SHOW_RULES = isDevENV() ? false : true; //for showing validation error, make it 'true'

const UnitDropdown = ({ unit, onSelectChange, value }) => {
  return (
    <Select
      style={styles.dropdownStyle}
      onChange={onSelectChange}
      // defaultValue={unit[0]}
      value={value}
    >
      <Option value={unit[0]}>{unit[0]}</Option>
      <Option value={unit[1]}>{unit[1]}</Option>
    </Select>
  );
};

/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name WrappedRightMainContent
 * @description It's the LCL/AIR total shipment shipping component
 * <br> <br>
 * **Example**
 * ```js
 *   <WrappedRightMainContent />
 * ```
 */
class WrappedRightMainContent extends Component {
  state = {};

  componentDidMount = () => {
    this.loadSummary();
  };

  /**
   * @description it updates load summary text
   * <br> <br>
   * **loadSummary() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  loadSummary = () => this.props.updateLoadSummaryText();

  /**
   * @description when total shipment's no. of unit input field is changed, this method is invoked
   * <br> <br>
   * **onInputNumChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | number        | input value, it only accepts numeric key press |

   * Returns: Type: void
   */
  onInputNumChange = (value) => {
    this.props.updateLclTotalShippment({
      quantity: value ? value : 1,
    });
    this.loadSummary();
  };

  /**
   * @description when total shipment total volume's unit dropdown and total weight's unit dropdown are changed, this method is invoked
   * <br> <br>
   * **onSelectChange(value, type) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | dropdown unit type e.g. `CFT`, `CBM`, `KG`, `LB` |
   * | type          | string        | whether total volume or total weight type i.e. `weight` or `volume` |

   * Returns: Type: void
   */
  onSelectChange = (value, type) => {
    if (type === 'weight') {
      this.props.updateLclTotalShippment({
        weightUnit: value,
      });
    } else {
      this.props.updateLclTotalShippment({
        volumeUnit: value,
      });
    }
    this.loadSummary();
  };

  /**
   * @description when total shipment's total volume input field is changed, this method is invoked
   * <br> <br>
   * **onVolInputChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | volume input onchange event, it accepts only numeric key press |

   * Returns: Type: void
   */
  onVolInputChange = (value) => {
    this.props.updateLclTotalShippment({
      totalVolume: value,
    });
    this.loadSummary();
  };

  /**
   * @description when total shipment's total weight input field is changed, this method is invoked
   * <br> <br>
   * **onWtInputChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | weight input onchange event, it accepts only numeric key press |

   * Returns: Type: void
   */
  onWtInputChange = (value) => {
    this.props.updateLclTotalShippment({
      totalWeight: value,
    });
    this.loadSummary();
  };

  render() {
    const { getFieldDecorator, getFieldsError, setFieldsValue } =
      this.props.form;

    const { quantity, totalVolume, volumeUnit, totalWeight, weightUnit } =
      this.props.totalShipment;

    // console.log(
    //   "totalShipment: ",
    //   quantity,
    //   totalVolume,
    //   volumeUnit,
    //   totalWeight,
    //   weightUnit
    // );

    //  //min. 0.4
    //  const patternWt = /^0\.[4-9]/;
    //min. 2 CM or 1.2 CM or 0.4 CM or 0.5
    const patternWt = /^(([1-9][0-9]*(\.[0-9]*)?)|(0\.[4-9]*))(\s*[A-Za-z]*)?$/;

    const rulesVol = [
      { required: SHOW_RULES, message: 'Required' },
      {
        pattern: patternWt,
        message: 'minimum is 0.4 ' + volumeUnit,
      },
    ];
    const rulesWt = [
      { required: SHOW_RULES, message: 'Required' },
      {
        pattern: patternWt,
        message: 'minimum is 0.4 ' + weightUnit,
      },
    ];

    return (
      <StyledParentDiv className="testBla1">
        {/* InputNumber */}
        <InputNumber
          min={1}
          // max={10}
          defaultValue={1}
          value={quantity}
          onChange={this.onInputNumChange}
          style={{ width: '75px', height: '36px' }}
          className="testBla1"
        />
        {/* Total Volume Custom Input */}
        <div
          style={{
            height: '52px',
            width: 'auto',
          }}
          className="testO1"
        >
          <Form
            layout="inline"
            className="testR1"
            style={{
              width: '100%',
              height: '100%',
              fontSize: '5px',
            }}
          >
            <Form.Item
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className="testBlu1"
            >
              {getFieldDecorator('volume', {
                initialValue: totalVolume,
                rules: rulesVol,
              })(
                <NumericCustomInput
                  addonAfter={
                    <UnitDropdown
                      unit={volumeUnitArr}
                      onSelectChange={(val) =>
                        this.onSelectChange(val, 'volume')
                      }
                      value={volumeUnit}
                    />
                  }
                  placeholder="Total Volume"
                  style={styles.inputStyle}
                  onChange={this.onVolInputChange}
                  className="testBlu1"
                />
              )}
            </Form.Item>
          </Form>
        </div>

        {/* Total Weight Custom Input */}
        <div style={{ height: '52px', width: 'auto' }} className="testO1">
          <Form
            layout="inline"
            className="testR1"
            style={{
              width: '100%',
              height: '100%',
              fontSize: '5px',
            }}
          >
            <Form.Item
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className="testR1"
            >
              {getFieldDecorator('weight', {
                initialValue: totalWeight,
                rules: rulesWt,
              })(
                <NumericCustomInput
                  addonAfter={
                    <UnitDropdown
                      unit={weightUnitArr}
                      onSelectChange={(val) =>
                        this.onSelectChange(val, 'weight')
                      }
                      value={weightUnit}
                    />
                  }
                  placeholder="Total Weight"
                  style={styles.inputStyle}
                  onChange={this.onWtInputChange}
                  className="testR1"
                />
              )}
            </Form.Item>
          </Form>
        </div>

        {/* Total Summary */}
        <div
          style={{
            height: '34px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="testR1"
        >
          <StyledTotalSummary className="testR1">
            <span>Shipment Total:</span>
            <span>&nbsp;{quantity} Unit,</span>
            <span>
              &nbsp;{parseFloat(totalVolume || 0).toFixed(2)} {volumeUnit},
            </span>
            <span>
              &nbsp;{parseFloat(totalWeight || 0).toFixed(2)} {weightUnit}
            </span>
          </StyledTotalSummary>
        </div>
      </StyledParentDiv>
    );
  }
}

WrappedRightMainContent.propTypes = {
  /**
   * lcl box/pallet data
   */
  totalShipment: PropTypes.object,
};

const RightMainContent = Form.create({ name: 'rightMainContent_form' })(
  WrappedRightMainContent
);

const mapStateToProps = (state) => {
  return {
    totalShipment: state.form.lclAirShipping.totalShipment,
  };
};

export default connect(mapStateToProps, actions)(RightMainContent);

const StyledParentDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
`;
const StyledTotalSummary = styled.span`
  padding: 0px 10px 0px 0px;
  font-size: 13px;
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #0093ee;
`;
const styles = {
  dropdownStyle: {
    width: '70px',
    height: '28px',
    fontSize: '12px',
    padding: '0px 0px 0px 5px',
    lineHeight: '20px',
    color: '#43637c',
  },
  inputStyle: {
    width: '230px',
    height: '36px',
    fontSize: '11px',
  },
};
